<template>
    <div>
      <!--<el-form class="form-horizontal form-edit">-->
          <!--<el-form-item :model="entity">-->
            <!---->
          <!--</el-form-item>-->
      <!--</el-form>-->
      <!--:rules="rules2" :ref="entity3"-->
      <el-form :model="entity" status-icon label-width="100px" class="form-horizontal form-edit">
        <el-form-item label="账号" prop="account" class="from-group">
          <el-input v-model="entity.account" style="width:250px;"/>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <!--auto-complete="new-password"-->
          <el-input type="password" v-model="entity.pwd" autocomplete="off" style="width:250px;"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="entity.checkPass" autocomplete="off" style="width:250px;"></el-input>
        </el-form-item>
        <el-form-item label="用户名称" prop="uName">
          <el-input v-model="entity.uName" style="width:250px;"/>
        </el-form-item>
        <el-form-item label="用户级别" prop="uLevel">
          <el-select style="width:300px;" v-model="entity.uLevel">
            <el-option
              v-for="item in dictionarys"
              :key="item.valId"
              :label="item.valName"
              :value="item.valId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色ID" prop="roleId">
          <el-select style="width:300px;" v-model="entity.roleId">
            <el-option
              v-for="item in permissions"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId">
            </el-option>
          </el-select>
          <!--<el-input v-model="entity.roleId" style="width:250px;"/>-->
        </el-form-item>
        <el-form-item label="角色信息" prop="roleCode">
          <!--<el-col v-for="item in userRole" :key="index">-->
            <!--<el-col style="width:250px;" v-if="item.valId == entity.roleId" v-model="entity.roleCode = item.desc"/>-->
          <!--</el-col>-->
          <el-input v-model="entity.roleCode" style="width:300px;"/>
        </el-form-item>



        <fieldset>
          <legend>功能权限</legend>
          <div>
            <div v-for="">

            </div>
          </div>
        </fieldset>

      </el-form>

      <!--<fieldset>-->
        <!--<legend>功能权限</legend>-->
        <!--<div>-->
          <!--<div v-for="">-->

          <!--</div>-->
        <!--</div>-->
      <!--</fieldset>-->

        <span slot="footer" class="dialog-footer">
          <el-button @click="redirect">取 消</el-button>
          <el-button type="primary" @click="submitAdd">提 交</el-button>
        </span>

    </div>
</template>

<script>

    export default {
        data() {
          return {
            entity: {},
            permissions: [],
            dictionarys: [],
            jurisdiction: []

          }
        },
      // created () {
      //     this.entity = {}
      // },

      methods: {

        //表单提交
        submitAdd: function() {

        },

        //路径返回
        redirect: function() {

          this.$router.push({
            path : '/sys/Admin_Management'
          })

        },

        //变量的赋值
        assignment: function() {
          this.permissions = this.$store.state.user.perms
          this.dictionarys = this.$store.state.dictionary.dictionarys
          // this.dictionarys = this.dictionarys.dictionarys

          console.log(this.dictionarys)
          console.log(this.permissions)

        }

      },

      mounted: function () {

        this.assignment()

      }
    }
</script>

<style scoped>

.zlf-span{

    /*margin-left: 290px;*/
    align-content: center!important;

}

</style>



// WEBPACK FOOTER //
// src/pages/auxiliary/Admin_add.vue